export default "__VITE_ASSET__C0zNl20o__"